module.exports = __webpack_public_path__ + "img/erweima.cc4e2381.jpg";